import googleplay from "../../assets/img/G-Play.png";
import applestore from "../../assets/img/A-Store.png";
import qr from "../../assets/img/qr1.png";
import styles from "../../assets/css/featureNotAvailable.module.scss";
import { FEATURE_NOT_AVAILABLE_MESSAGE } from "../../constants";
import { downloadApp as defaultDownloadApp } from "../../libs/utils";

const FeatureNotAvailable = ({
  header = "",
  displayText = true,
  defaultQR,
  downloadPath = false,
  downloadApp,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>{header}</div>
      <div className={styles.message}>
        {displayText ? FEATURE_NOT_AVAILABLE_MESSAGE : ""}
      </div>
      {/* <div className={styles.appLogoImageBox}>
        <div onClick={() => downloadApp("iOS")}>
          <img
            src={applestore}
            alt="Click Here to Get iOS App"
            className={styles.appLogo}
          />
        </div>
        <div className={styles.appLogoAndroid}>
          <div onClick={() => downloadApp("android")}>
            <img
              src={googleplay}
              alt="Click here to get Android App"
              className={styles.appLogo}
            />
          </div>
        </div>
      </div> */}
      <div className={styles.downloadBox}>
        <div>
          <img
            src={defaultQR ? defaultQR : qr}
            className={defaultQR ? styles.defaultQrImage : styles.qrImage}
          />
        </div>
        <div className={styles.appLogoImageBox}>
          <div
            onClick={
              downloadPath
                ? () => downloadApp()
                : () => defaultDownloadApp("iOS")
            }
          >
            <img
              src={applestore}
              alt="Click Here to Get iOS App"
              className={styles.appLogo}
            />
          </div>
          <div
            onClick={
              downloadPath
                ? () => downloadApp()
                : () => defaultDownloadApp("android")
            }
          >
            <img
              src={googleplay}
              alt="Click here to get Android App"
              className={styles.appLogo}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default FeatureNotAvailable;
